<template>
  <div id="design-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=1.5
        position="bottom 23% center"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>
    
    <v-container fluid grid-list-md>
      <v-layout column wrap>
        <v-flex xs12 sm6>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title><h4>Color Palette</h4></v-toolbar-title>
            </v-toolbar>
            <v-container fluid>
              <v-layout column>
                <v-flex>
                  <v-data-table
                    :headers="headers"
                    :items="Colors"
                    hide-actions
                    light
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.purpose }}</td>
                      <td class="text-xs-center" :style="{backgroundColor: props.item.hex}">
                        <v-card
                          color="grey darken-4"
                          style="color: white;"
                          width="75"
                          flat
                        >{{ props.item.hex }}</v-card>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex>
                  <v-card-actions>
                    <v-btn 
                      exact 
                      href="http://chir.ag/projects/name-that-color/#FFC107"
                    >
                      Color Names
                      <v-icon right> mdi mdi-open-in-new</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
import ColorCodes from './ColorCodes'
export default {
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1538912471706-90fbf8891e9c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjF9&s=60f4ef06c93f3aa2cc8839a05fab7989&auto=format&fit=crop&w=1350&q=80',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Purpose',
          align: 'left',
          sortable: false,
          value: 'purpose'
        },
        {
          text: 'Hex',
          align: 'left',
          value: 'hex'
        }
      ],
      Colors: ColorCodes.data.colors[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/design/Design.vue